import React from 'react';

function Card({ children, className }) {
  return <div className={`rounded-2xl bg-white ${className}`}>{children}</div>;
}

export default Card;
